<template>
  <div>
    <b-row class="d-flex align-items-center">
      <b-col cols="8">
        <h1 class="font-weight-bolder mb-0">In-App Messaging</h1>
      </b-col>
      <b-col cols="4" class="text-right">
        <b-link :to="{ name: 'marketing-in-app-messaging-new' }">
          <b-button size="md" variant="primary">
            <feather-icon icon="PlusIcon" />
            <span class="text-lg text-nowrap" style="margin-left: 4px"
              >New In-App Messaging</span
            >
          </b-button>
        </b-link>
      </b-col>
    </b-row>

    <b-row class="mt-1">
      <b-col cols="12">
        <b-card>
          <b-row>
            <b-col cols="3">
              <p class="font-weight-bold mb-0">Search</p>
              <b-form-input
                v-model="searchQuery"
                placeholder="Search by name or descriptions"
              />
            </b-col>
            <b-col cols="3">
              <p class="font-weight-bold mb-0">Status</p>
              <v-select
                :value="option"
                :options="options"
                :reduce="(val) => val.value"
                :clearable="false"
                @input="(val) => (option = val.value)"
                class="w-100"
              />
            </b-col>

            <b-col cols="3">
              <p class="font-weight-bold mb-0">Date Range</p>
              <flat-pickr
                id="endDate"
                v-model="endDate"
                class="form-control"
                :config="configDate"
                placeholder="mm/dd/yyyy"
              />
            </b-col>
            <b-col cols="1" class="align-content-end">
              <b-button variant="outline-secondary" style="height: auto"
                >Filter</b-button
              >
            </b-col>
          </b-row>

          <b-table
            :items="items"
            :fields="tableColumns"
            responsive
            show-empty
            primary-key="id"
            thead-class="text-nowrap"
            class="mt-1"
          >
            <!-- <template #empty>
                <div v-if="list.loading" class="text-center text-dark my-2">
                  <p>Loading... Please wait</p>
                </div>
        
                <div
                  v-else-if="!list.loading && fetchUsers.length === 0"
                  class="text-center text-dark my-2"
                >
                  No matching records found
                </div>
              </template> -->

            <template #cell(name)="{ item }">
              <div class="d-flex align-items-center font-weight-bold id-column">
                <span class="text-nowrap">{{ item.name }}</span>
              </div>
            </template>

            <template #cell(type)="{ item }">
              <b-media vertical-align="center">
                {{ item.type }}
              </b-media>
            </template>

            <template #cell(start)="{ item }">
              <b-media vertical-align="center">
                <div class="d-flex align-items-center">
                  {{ item.start }}
                </div>
              </b-media>
            </template>
            <template #cell(status)="{ item }">
              <b-media vertical-align="center">
                <div
                  class="text-white bg-success d-flex rounded justify-content-center align-items-center font-weight-bolder"
                  style="padding: 2px 4px; width: fit-content"
                >
                  {{ item.status }}
                </div>
              </b-media>
            </template>
            <template #cell(end)="{ item }">
              <b-media vertical-align="center">
                <div class="d-flex align-items-center">
                  {{ item.end }}
                </div>
              </b-media>
            </template>
            <template #cell(target)="{ item }">
              <b-media vertical-align="center">
                <div class="d-flex align-items-center">
                  {{ item.target }}
                </div>
              </b-media>
            </template>
            <template #cell(actions)>
              <b-media vertical-align="center">
                <div class="d-flex align-items-center">
                  <b-button size="sm" variant="outline-secondary" class="mr-1">
                    Edit
                  </b-button>
                  <b-button size="sm" variant="outline-primary" class="mr-1">
                    View
                  </b-button>
                  <b-button size="sm" variant="outline-danger">
                    Delete
                  </b-button>
                </div>
              </b-media>
            </template>
          </b-table>
          <div class="mx-2 mb-2">
            <b-row>
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <span class="text-muted">
                  Showing 1-5 of 156 unassigned customers
                </span>
              </b-col>
              <!-- Pagination -->
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >
                <b-pagination
                  v-model="currentPage"
                  total-rows="1"
                  :per-page="10"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                >
                  <template #first-text
                    ><span class="text-success">First</span></template
                  >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                  <template #last-text
                    ><span class="text-info">Last</span></template
                  >
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Spinner from "@core/components/Spinner";
import {
  BButton,
  BCard,
  BCol,
  BPagination,
  BRow,
  BButtonGroup,
  BTable,
  BCardBody,
  BFormInput,
  BMedia,
  BLink,
  BAvatar,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    BButton,
    BCard,
    BRow,
    BCol,
    BTable,
    BMedia,
    BPagination,
    vSelect,
    Spinner,
    BButtonGroup,
    BTable,
    BCardBody,
    BFormInput,
    BAvatar,
    flatPickr,
    BLink,
  },
  data() {
    return {
      searchQuery: "",
      currentPage: 1,
      option: "Last 30 days",
      startDate: "",
      endDate: "",
      options: [
        { label: "Last 30 days", value: "last30days" },
        { label: "Last 7 days", value: "last7days" },
        { label: "Last 90 days", value: "last90days" },
      ],
      items: [
        {
          name: "Customer Satisfaction Survey",
          type: "Popup Modal",
          status: "Active",
          start: "2025-06-15",
          end: "2025-06-30",
          target: "New Users",
        },
        {
          name: "Promo Upsell",
          type: "Banner",
          status: "Draft",
          start: "2025-06-10",
          end: "2025-06-25",
          target: "All Users",
        },
      ],
      tableColumns: [
        { key: "name", label: "Name" },
        { key: "type", label: "Type" },
        { key: "status", label: "Status" },
        { key: "start", label: "Start" },
        { key: "end", label: "End" },
        { key: "target", label: "Target" },
        { key: "actions", label: "Actions" },
      ],
      configDate: {
        // dateFormat: 'd-m-Y',
        altFormat: "d-m-Y",
        altInput: true,
        static: true,
      },
    };
  },
  computed: {},
  async mounted() {},
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
